define([
	"dojo/_base/declare",
	"csi/form/Widget"
], function(declare, Widget) {

	const TEMPLATE_TYPE = "TemplateType";

	return declare(Widget, {
		isFieldEditable: function(/*Field*/field) {
			// DE29706: Template Type should be read only during copy
			if (field.m_id == TEMPLATE_TYPE && this.getFormData().getSource().m_action.m_id == "Copy") {
				return false;
			}

			return this.inherited(arguments);
		}
	});
});